// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6f60b82c","977":"dae8d05e"}[chunkId] + ".chunk.js";
};